import PrimerosMensajes from '../components/PrimerosMensajes'

/**
 * Agente IA › Speech: lo que el agente le dice al cliente al empezar, en solo
 * lectura (13-oct-2026).
 *
 * Hasta ese día esta pantalla tenía saludo, tono e instrucciones editables y un
 * «Publicar configuración». Ninguno estaba conectado: el servidor descartaba
 * los tres campos sin error, la pantalla decía «publicada correctamente» y al
 * recargar volvía a un saludo escrito acá —«Hola, soy el asistente virtual de
 * PGH…»— que el bot no mandó nunca. El tono y las instrucciones tampoco existen
 * en el agente: lo que el cliente lee es wording aprobado por negocio, y los
 * prompts del modelo (clasificador, Copiloto) están en el código. Publicar,
 * además, volvía a escribir los demás interruptores con lo que la pantalla
 * leyó al abrir. «Contacto proactivo» y «Webhook n8n» se fueron con ella: su
 * valor real lo fijan variables de ambiente del stack (`OUTREACH_MODE`,
 * `WEBHOOK_ENABLED`), y el item de `CONFIG#GLOBAL` que escribía no lo lee
 * ninguna Lambda — las perillas de Canales y CRM y de Costos tienen el mismo
 * problema, pendiente aparte.
 */
export default function Speech() {
  return (
    <div className="flex flex-col gap-5">
      <div className="rounded-card border border-info-border bg-info-light px-4 py-3 text-body text-info">
        Esto es lo que el agente le dice al cliente al empezar, según por dónde entra. Los textos
        salen del mismo código con el que el bot los manda; cambiarlos es un cambio de código con
        aprobación de negocio, no una edición desde el portal.
      </div>
      <PrimerosMensajes />
    </div>
  )
}
